import React from 'react';
import Svg from 'react-inlinesvg';
import IconClose from '../../../../assets/icons/CloseIcon.svg';
import { Shell, ContentWrap, HeadingRow, ModalTitle, Button } from './styled';

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <Shell isOpen={isOpen}>
      <ContentWrap>
        <HeadingRow>
          <ModalTitle>Interactive Demo</ModalTitle>

          <Button onClick={onClose}>
            <Svg src={IconClose} className="icon-close" onClick={onClose} />
            Exit demo
          </Button>
        </HeadingRow>
        {children}
      </ContentWrap>
    </Shell>
  );
};

export default Modal;
